import cBreadcrumb from './cBreadcrumb.vue';

export default {
    install(app) {
        app.component('cBreadcrumb', cBreadcrumb);
    },
};
